import React, { useEffect } from 'react';

const AdminDashboard = () => {
    useEffect(() => {
        document.title = "SwavAI - Admin Dashboard";
    }, []);

    return (
        <div>
            <h1>Admin Dashboard</h1>
            {/* Admin content */}
        </div>
    );
};
export default AdminDashboard;